var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.notFound)?_c('div',{staticClass:"mt-5 ml-5"},[_vm._v("Référent introuvable")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }